function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "md-logo-color_svg__a",
  x1: 5.511,
  y1: 9.272,
  x2: 5.923,
  y2: 9.327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.268,
  stopColor: "#441b19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.733,
  stopColor: "#441b19",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "md-logo-color_svg__b",
  x1: 5.008,
  y1: 7.588,
  x2: 7.14,
  y2: 6.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.219,
  stopColor: "#4b0726",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4b0726",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "md-logo-color_svg__c",
  x1: 4.247,
  y1: 15.732,
  x2: 6.153,
  y2: 0.213,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#ff0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#ffff1c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.537,
  stopColor: "#ffff64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.722,
  stopColor: "#ffffd5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.788,
  stopColor: "#fff"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 14.967a.5.5 0 00.43.56h.07a.5.5 0 00.5-.44l1.218-8.832-.72-2.148z",
  fill: "#de4d53"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.887 1.285L4 14.967a.5.5 0 00.43.56h.07a.5.5 0 00.5-.44L6.607 3.433z",
  fill: "#eeac3c"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 15.523a.557.557 0 01-.068-.005.5.5 0 01-.427-.564l2-14.5a.492.492 0 01.563-.427.5.5 0 01.427.563l-2 14.501a.5.5 0 01-.495.432z",
  fill: "#96c25e"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 15.523a.557.557 0 01-.068-.005.5.5 0 01-.427-.564l2-14.5a.492.492 0 01.563-.427.5.5 0 01.427.563l-2 14.501a.5.5 0 01-.495.432z",
  fill: "#49a9df"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M.5 15.523a.557.557 0 01-.068-.005.5.5 0 01-.427-.564l2-14.5a.492.492 0 01.563-.427.5.5 0 01.427.563l-2 14.501a.5.5 0 01-.495.432z",
  fill: "#8f429b"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.671 3.778l-.274-.827-1.69 12.242a.493.493 0 00.215.44.511.511 0 00.168-.312z",
  transform: "translate(-.7 -.2)",
  opacity: 0.25,
  fill: "url(#md-logo-color_svg__a)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#md-logo-color_svg__b)",
  d: "M5.692 2.719L5.02 7.591l1.44 4.13.65-4.716-1.418-4.286z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.2 15.723a.557.557 0 01-.068-.005.5.5 0 01-.427-.564l2-14.5a.492.492 0 01.563-.427.5.5 0 01.427.563l-2 14.501a.5.5 0 01-.495.432z",
  transform: "translate(-.7 -.2)",
  fill: "url(#md-logo-color_svg__c)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.37.463A.554.554 0 0011.893 0a.526.526 0 00-.533.455L8.846 9.068 5.986.428a.489.489 0 01.01.162L5.67 2.663l2.73 8.24a.495.495 0 00.483.343.5.5 0 00.472-.36l2.343-8.008 1.681 12.186a.5.5 0 00.495.432.476.476 0 00.069-.005.5.5 0 00.427-.563z",
  fill: "#fff"
});

function SvgMdLogoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.376 15.527"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default __webpack_public_path__ + "md-logo-color.4b2a1.svg";
export { SvgMdLogoColor as ReactComponent };